import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation, useOutlet } from "react-router-dom";

const variants = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] } },
  exit:    { opacity: 0, y: -8, transition: { duration: 0.35, ease: [0.4, 0, 1, 1] } },
};

export default function PageTransition() {
  const location = useLocation();
  const element = useOutlet();

  // Scroll to top on every route change
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div key={location.pathname} variants={variants} initial="initial" animate="animate" exit="exit">
        {element}
      </motion.div>
    </AnimatePresence>
  );
}
